import { render, staticRenderFns } from "./PendingApplications.vue?vue&type=template&id=32125032&"
import script from "./PendingApplications.vue?vue&type=script&lang=js&"
export * from "./PendingApplications.vue?vue&type=script&lang=js&"
import style0 from "./PendingApplications.vue?vue&type=style&index=0&id=32125032&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports